import './Terms.css';
import Header from './Components/Header';

function Terms() {
  return (
    <div className="terms-container">
      <div className="terms-header-bg">
        <Header />
      </div>
      <div className="terms-wrapper">
        <h1>Terms of Service</h1>

        <section>
          <h2>Introduction</h2>
          <p>
            Welcome to our Terms of Service page. These terms govern your use of our website and services.
          </p>
        </section>

        <section>
          <h2>Acceptance of Terms</h2>
          <p>
            By accessing or using our services, you agree to be bound by these terms and conditions.
          </p>
        </section>

        <section>
          <h2>User Responsibilities</h2>
          <p>
            As a user, you are responsible for maintaining the confidentiality of your account and complying with applicable laws.
          </p>
        </section>

        <section>
          <h2>Prohibited Uses</h2>
          <p>
            You agree not to use our services for any unlawful activities, including but not limited to spamming, harassment, or illegal distribution of content.
          </p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>
            Our liability for any claims related to our services is limited to the amount you paid for the service in question. We are an event search tool. We are not responsible for any issues or complications with ticketing or the events themselves.
          </p>
        </section>

        <section>
          <h2>Changes to These Terms</h2>
          <p>
            We may update these Terms of Service from time to time. Any changes will be posted on this page.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have any questions about these Terms of Service, feel free to contact us.</p>
        </section>
      </div>
    </div>
  );
}

export default Terms;
